import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  PipeTransform,
  SimpleChanges,
  Injector,
  ChangeDetectionStrategy
} from '@angular/core';
import { CustomSelectOption } from './custom-select-option';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LowerCasePipe, TitleCasePipe, UpperCasePipe, NgClass, AsyncPipe } from '@angular/common';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';

@Component({
    selector: 'app-select-one',
    templateUrl: './select-one.component.html',
    styleUrls: ['./select-one.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectOneComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatPrefix, MatSelect, MatOption, MatSelectSearchComponent, FormsModule, ReactiveFormsModule, NgClass, AsyncPipe]
})
export class SelectOneComponent
  implements ControlValueAccessor, OnInit, OnChanges
{
  @Input() collection: CustomSelectOption[] = new Array<CustomSelectOption>();
  @Input() label: string = null;
  @Input() selectedValue: any = null;
  @Input() buscaComPesquisa = false;
  @Output() valueChanges = new EventEmitter();
  @Input() descricaoPadrao;
  @Input() valorPadrao = '';
  @Input() pipeName;
  @Input() buscaIdDesc: boolean;
  @Input() enterPesquisar = false;
  @Input() panelWidth?: string | number;
  @Input() fieldWidth?: number;
  @Input() searchControl?: UntypedFormControl;
  @Input() useExternalSearch = false;

  private readonly pipeTransformMap: { [key: string]: PipeTransform } = {
    upperCase: this.injector.get<UpperCasePipe>(UpperCasePipe),
    lowerCase: this.injector.get<LowerCasePipe>(LowerCasePipe),
    titleCase: this.injector.get<TitleCasePipe>(TitleCasePipe),
  };

  protected onDestroyComponent = new Subject<void>();
  disabled = false;
  filtroBusca: UntypedFormControl = new UntypedFormControl('');
  objetosRetornados: ReplaySubject<CustomSelectOption[]> = new ReplaySubject<CustomSelectOption[]>(1);

  descricaoPadraoApresentar: string;
  hasUserSelected = false;

  constructor(private readonly injector: Injector) {}

ngOnInit(): void {
  this.descricaoPadraoApresentar = this.descricaoPadrao;

  const control = this.searchControl || this.filtroBusca;

  control.valueChanges
    .pipe(takeUntil(this.onDestroyComponent))
    .subscribe((value: string) => {
      if (this.enterPesquisar && value && value.length > 0) {
        this.descricaoPadraoApresentar = '';
      } else if (!value || value.length === 0) {
        this.descricaoPadraoApresentar = this.descricaoPadrao;
      }

      if (!this.useExternalSearch) {
        this.filtrarResultados();
      }
    });
}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.collection.length) {
      this.objetosRetornados.next(this.collection);
    }
  }
  onChange: any = () => {};
  onTouched: any = () => {};

  getTransformedText(text: string) {
    this.pipeName = this.pipeName ?? 'titleCase';
    const pipe = this.pipeTransformMap[this.pipeName];
    if (pipe) {
      return pipe.transform(text);
    }
  }

   private isEmptyValue(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  get highlightDefaultOption(): boolean {
    if (!this.descricaoPadraoApresentar) { return false; }

    return !this.hasUserSelected &&
           (this.isEmptyValue(this.selectedValue) || this.selectedValue === this.valorPadrao);
  }

  get highlightFirstOption(): boolean {
    if (this.descricaoPadraoApresentar) { return false; }

    return !this.hasUserSelected &&
           this.isEmptyValue(this.selectedValue);
  }

  writeValue(value: any): void {
    this.selectedValue = value ?? null;

    this.hasUserSelected = !(this.isEmptyValue(value) || value === this.valorPadrao);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChangeValue(event: any) {
    this.selectedValue = event;
    this.valueChanges.emit(event);
    this.onChange(event);
    this.hasUserSelected = !(
      this.isEmptyValue(event) || event === this.valorPadrao
    );
  }

  filtrarResultados() {

    if (!this.collection) {
      return;
    }

    let busca = this.filtroBusca.value;
    if (busca) {
      busca = busca.toLowerCase();
    } else {
      this.objetosRetornados.next(this.collection.slice());
      return;
    }

    this.objetosRetornados.next(
        this.collection.filter((obj) => {
          const textoBusca = obj.label.toLowerCase();
          const identificador = textoBusca.substring(0, 18).replace(/[.\-/]/g, '');
          const descricao = textoBusca.substring(18);

          if (this.buscaIdDesc) {
            const termoBusca = busca.replace(/[.\-/]/g, '');

            return (
              (termoBusca.length > 0 && identificador.includes(termoBusca)) ||
              (descricao.length > 0 && descricao.includes(busca))
            );
          }
          return textoBusca.includes(busca);
        })
      );
  }
}
